var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"find_account_wrap"},[_c('v-text-field',{attrs:{"placeholder":"Find existing artist account","hide-details":"","dense":"","clearable":"","loading":_vm.isLoading},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }